import type { ProductFragment } from "@qw/graphql";
import { Badge, Button, Collapsible, CollapsibleContent, CollapsibleTrigger, Icon, Separator } from "@qw/ui";
import { Link, useNavigate } from "react-router";

import { ProductCard } from "./product-card";

interface ProductsCarrierSectionProps {
  carrierName: string;
  carrierId: string | null;
  products: ProductFragment[];
}

export const ProductsCarrierSection = ({ carrierName, carrierId, products }: ProductsCarrierSectionProps) => {
  const navigate = useNavigate();

  return (
    <>
      <Collapsible defaultOpen={false} className="@container">
        <div className="flex items-center justify-between">
          <CollapsibleTrigger asChild>
            <Button variant="ghost" size="sm" className="group">
              <Badge variant="secondary" size="2xs" type="square">
                {products.length}
              </Badge>
              {carrierName}
              <Icon icon="keyboard_arrow_down" className="transition-transform group-data-[state=open]:rotate-180" />
            </Button>
          </CollapsibleTrigger>
          <div className="flex items-center gap-1">
            {carrierId && (
              <Button asChild variant="ghost" size="sm">
                <Link to={`/carriers/${carrierId}`}>
                  <Icon icon="edit_square" className="mr-1" />
                  Carrier Details
                </Link>
              </Button>
            )}
          </div>
        </div>
        <CollapsibleContent className="rounded border bg-card mt-1">
          {products.map((product) => (
            <ProductCard key={product.id} product={product} onClick={() => navigate(`/products/${product.id}`)} />
          ))}
        </CollapsibleContent>
      </Collapsible>
      <Separator className="my-6" />
    </>
  );
};
